import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'

import styles from './styles.scss'

const footerHeight = 80
const headerHeight = 128
const subHeaderHeight = 96

const buildHeightValue = (hasHeader, hasFooter, hasSubHeader) => {
  let usedSpace = 0
  if (hasHeader) usedSpace += headerHeight
  if (hasFooter) usedSpace += footerHeight
  if (hasSubHeader) usedSpace += subHeaderHeight

  return `calc(100vh - ${usedSpace}px )`
}

const Content = (props) => {
  const {
    boxProps, children, hasHeader, hasFooter, hasSubHeader, style,
  } = props

  const contentHeight = useMemo(() => (
    buildHeightValue(hasHeader, hasFooter, hasSubHeader)
  ), [hasHeader, hasFooter, hasSubHeader])

  return (
    <Box
      className={styles.root}
      flexDirection="column"
      flexShrink="0"
      height={contentHeight}
      padding="large"
      paddingBottom={[160, 'large']}
      style={style}
      {...boxProps}
    >
      {children}
    </Box>
  )
}

Content.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  hasFooter: PropTypes.bool,
  hasHeader: PropTypes.bool,
  hasSubHeader: PropTypes.bool,
  style: PropTypes.object,
}

Content.defaultProps = {
  hasFooter: true,
  hasHeader: true,
}

export default Content
